import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { AutofocusDirective } from '../../../../shared/directives/autofocus.directive';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { AvgebaeudeService, GebaeudeEgidRequestMeta } from '../../../../core/av-api';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { GebaeudeFormService } from '../../gebaeude-form.service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-gebaeude-suche-egid-kantgid',
  templateUrl: './gebaeude-suche-egid-kantgid.component.html',
  styleUrls: ['./gebaeude-suche-egid-kantgid.component.scss'],
  imports: [
    FormsModule,
    CapFormRowDirective,
    CapFormControlComponent,
    AutofocusDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GebaeudeSucheEgidKantgidComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  gebaeudeStrasse: GebaeudeEgidRequestMeta;

  // only egid or kantgid input allowed
  isGwrInput: boolean;
  isKantgidInput: boolean;
  isAvPlusActive: boolean = false;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private avgebaeudeService: AvgebaeudeService,
    private route: ActivatedRoute,
    private formService: GebaeudeFormService,
    private router: Router,
    private appFormatConfigService: FormatConfigService,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    if (this.stateService.lastRequest && this.stateService.lastSearchMode === SearchMode.searchFachId) {
      this.gebaeudeStrasse = this.stateService.lastRequest;
    } else {
      this.gebaeudeStrasse = <GebaeudeEgidRequestMeta>{};
    }
    this.addSub(
      this.avgebaeudeService.searchGebaeudeEgidTemplate().subscribe((template) => {
        this.gebaeudeStrasse = this.copyLastRequest(template, SearchMode.searchFachId);
        this.onUpdateInputValues();
      })
    );

    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isAvPlusActive = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
      })
    );
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.gebaeudeStrasse;
    this.formService.submit(this.form, SearchMode.searchFachId, this.gebaeudeStrasse, this.router, this.route, true);
  }

  onReset(autofocusInput) {
    this.form.reset();
    this.addSub(
      this.avgebaeudeService.searchGebaeudeEgidTemplate().subscribe((template) => {
        this.gebaeudeStrasse = template;
        autofocusInput.focus();
      })
    );
  }

  onUpdateInputValues() {
    this.isKantgidInput = false;
    this.isGwrInput = false;
    if (this.gebaeudeStrasse && this.gebaeudeStrasse.gwrEgid) {
      this.isGwrInput = this.gebaeudeStrasse.gwrEgid.length > 0;
    }
    if (this.gebaeudeStrasse && this.gebaeudeStrasse.kantonalerGid) {
      this.isKantgidInput = this.gebaeudeStrasse.kantonalerGid.length > 0;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
